import { render, staticRenderFns } from "./OntologyTree.vue?vue&type=template&id=4cca4912&scoped=true&"
import script from "./OntologyTree.vue?vue&type=script&lang=js&"
export * from "./OntologyTree.vue?vue&type=script&lang=js&"
import style0 from "./OntologyTree.vue?vue&type=style&index=0&id=4cca4912&prod&scoped=true&lang=css&"
import style1 from "./OntologyTree.vue?vue&type=style&index=1&id=4cca4912&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cca4912",
  null
  
)

export default component.exports